import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { useFilterContext } from '../contexts/FilterContext';
import { handleFilterStateRoute } from '../helpers/filters';

/**
 * Abre a análise de unidades com os filtros atuais da Visão Geral e, quando houver, só as unidades informadas.
 * Usado pelo "Ver Detalhes" dos cards, para que a lista aberta seja a das unidades contadas no card.
 */
export function useNavigateToUnitsAnalysis(): (unitIds: string[]) => void {
  const history = useHistory();
  const { clients, selectedOptions } = useFilterContext();
  const [profile] = useState(getUserProfile);

  return useCallback((unitIds: string[]) => {
    const filter = handleFilterStateRoute(clients, selectedOptions, profile);

    if (unitIds.length) {
      filter.units = unitIds;
    }

    history.push('/analise/unidades', filter);
  }, [clients, history, profile, selectedOptions]);
}
